import React from "react";
import contextProvider from "../../contextProvider";
import { LinkContainer } from "react-router-bootstrap";
import { Row, Col, ListGroup, ListGroupItem } from "reactstrap";

import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../_L0_components/Widgets/_LoadingKit";

import NotesEditor from "../Elements/NotesEditor";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import ReactOModal from "../../_L1_components/Elements/ReactOModal";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
// import ReactOCollapse from "../../_L1_components/Elements/ReactOCollapse";
import ReactOTable from "../../_L1_components/Elements/ReactOTable";
import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import Section from "../../_L1_components/Layout/Section";
import SectionNEW from "../../_L1_components/Layout/SectionNEW";
import Panel from "../../_L1_components/Layout/Panel";
import SpectroChart from "../Elements/SpectroChart";
import SpectroChart2 from "../Elements/SpectroChart2";
import BandwidthOverlapChart from "../Elements/BandwidthOverlapChart";
import ListView from "../Subroutes/MeasureResults/ListView";
import GridView from "../Subroutes/MeasureResults/GridView";
// import download from "downloadjs";

class ProbeMeasureResults extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: {},
      _collapse_controllers: {},
      viewMode: "list",
      bssid_active: undefined,
      zoom_image: false,
    };
    super(props, initState);
    this.child = React.createRef();
    this._autorefresh = null;
    this.phaseColors = [
      "#0774F2",
      "#0976F2",
      "#0C78F2",
      "#0F7BF2",
      "#127DF2",
      "#1580F3",
      "#1882F3",
      "#1B84F3",
      "#1E87F3",
      "#2189F4",
      "#248CF4",
      "#278EF4",
      "#2A91F4",
      "#2D93F4",
      "#3095F5",
      "#3398F5",
      "#359AF5",
      "#389DF5",
      "#3B9FF6",
      "#3EA1F6",
      "#41A4F6",
      "#44A6F6",
      "#47A9F6",
      "#4AABF7",
      "#4DAEF7",
      "#50B0F7",
      "#53B2F7",
      "#56B5F8",
      "#59B7F8",
      "#5CBAF8",
      "#5FBCF8",
      "#62BFF9",
    ];

    this._resultsDataCache = {};

    this.apiStore = null;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  getProbeConf() {
    this.apiStore.fire("probe_cst_sync_status", {
      data: {
        probeuid: this.props.match.params.probeuid,
      },
      ___onSuccess: (status, data) => {
        this.setState({
          conf_set: data,
        });
      },
    });
  }

  getStatusName(data) {
    const { errors, steps, discearly } = data || {};

    if (discearly) {
      return <span className="text-danger">Early drop by AP</span>;
    }

    if (errors > 0) {
      const stp = steps.find((phase) => !/^(\d+)$/.test(phase[1]));
      return <span className="text-danger">Error on {stp[0]}</span>;
    } else {
      return <span className="text-success">OK</span>;
    }
  }

  onClick = () => {
    if (this.viewMode == "grid") {
      this.child.current.formatGrid();
    }
  };

  handleZoomImage = () => this.setState({ zoom_image: !this.state.zoom_image });

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
    this._notes_editing_ctrl.setTs(this.props.match.params.ts);
    if (
      this.getAppContext().getLocalStorageService().isSet("results_view_mode")
    ) {
      this.viewMode = this.getAppContext()
        .getLocalStorageService()
        .get("results_view_mode");
    } else {
      this.viewMode = "list";
      this.getAppContext()
        .getLocalStorageService()
        .set("results_view_mode", "list");
    }
    this.getProbeConf();
  }

  onComponentDidUpdate() {
    this._notes_editing_ctrl.setTs(this.props.match.params.ts);
  }

  setTableClassName(row, data, tableOfSort) {
    let className = {};
    let names = "";
    if (row.is_reference && !this.state.bssid_active) {
      names = "reference-row";
    } else if (
      row.is_reference &&
      this.state.bssid_active == data.reference.bssid_orig
    ) {
      names = "reference-row-active";
    }

    if (this.state.bssid_active) {
      if (
        this.state.bssid_active == row.bssid_orig &&
        data.reference.bssid_orig &&
        !row.is_reference
      ) {
        names = "active-bssid-primary";
      }

      if (
        this.state.bssid_active == row.bssid_orig &&
        this.state.bssid_active != data.reference.bssid_orig &&
        !row.is_reference
      ) {
        names = "active-bssid";
      }
    } else if (!this.state.bssid_active && this.state.over) {
      names = "active-bssid_generic";
    }

    if (tableOfSort.includes(row)) {
      className = { className: names + " class-tr" };
    } else {
      className = { className: names };
    }

    return className;
  }

  setTooltipText(row, data) {
    let text;

    if (row.is_reference || row.bssid_orig == data.reference.bssid_orig) {
      if (data.occurrences[data.reference.bssid_orig] == 1) {
        text =
          "Measure at " +
          this.getAppContext().momentjs(data.ts, "X").format("L LTS");
      } else {
        text = (
          <div>
            <div>
              Measure at{" "}
              {this.getAppContext().momentjs(data.ts, "X").format("L LTS")}
            </div>
            <br />
            {data.occurrences[row.bssid_orig]} ESSID announced by the same AP{" "}
            {row.bssid_info ? (
              row.bssid_info.ap_custom_data &&
              row.bssid_info.ap_custom_data.name ? (
                <div>{row.bssid_info.ap_custom_data.name}</div>
              ) : (
                <div>
                  {row.bssid_info.long_desc
                    ? "from " + row.bssid_info.long_desc
                    : "from " + row.bssid_orig}
                </div>
              )
            ) : (
              "from " + row.bssid_orig
            )}{" "}
            (Does not generate overlap by its multiple ESSID)
          </div>
        );
      }
    } else if (
      data.overlaps[row.bssid_orig] &&
      data.occurrences[row.bssid_orig] > 1
    ) {
      let contribution =
        Math.round(data.overlaps[row.bssid_orig].overlap * 100) / 100;
      text = (
        <div>
          <div>
            {contribution != 0
              ? contribution + ":  Contribution to overlap index"
              : "Contribution to overlap index less than 0.01"}
          </div>
          <br />
          <div>
            {data.occurrences[row.bssid_orig]} ESSID with overlaps announced by
            the same AP{" "}
            {row.bssid_info ? (
              row.bssid_info.ap_custom_data &&
              row.bssid_info.ap_custom_data.name ? (
                <div>{row.bssid_info.ap_custom_data.name}</div>
              ) : (
                <div>
                  {row.bssid_info.long_desc
                    ? "from " + row.bssid_info.long_desc
                    : "from " + row.bssid_orig}
                </div>
              )
            ) : (
              "from " + row.bssid_orig
            )}{" "}
            (Overlap count based on the AP, not on its multiple ESSID)
          </div>
        </div>
      );
    } else if (
      data.overlaps[row.bssid_orig] &&
      data.occurrences[row.bssid_orig] == 1
    ) {
      let contribution =
        Math.round(data.overlaps[row.bssid_orig].overlap * 100) / 100;
      text = (
        <span>
          {contribution != 0
            ? contribution + ":  Contribution to overlap index"
            : "Contribution to overlap index less than 0.01"}
        </span>
      );
    }

    return text;
  }

  parseOis(string) {
    let parsed = "";
    let occ = (string.match(/,/g) || []).length;

    if (occ == 0) {
      parsed = "OI: " + string;
    } else {
      parsed = "OIs: " + string.replace(/,/g, ", ");
    }

    return parsed;
  }

  loadMeasureResults(data, cb) {
    if (this._autorefresh != null) {
      clearTimeout(this._autorefresh);
    }
    this.setState(
      {
        loading: true,
      },
      () => {
        this._notes_editing_ctrl.getNotes();
        this.apiStore.fire("get_measure_results", {
          data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: this.props.match.params.bssid,
            ts: this.props.match.params.ts,
            viewrange: data,
          },
          ___onSuccess: (status, data) => {
            this._resultsDataCache[this.props.match.params.ts] = data;
            this.setState(
              {
                data: data,
                rrd_step: data.measureData.rrd_step,
                _curr_ts: this.props.match.params.ts,
                loading: false,
              },
              () => {
                if (
                  (data.measured_times &&
                    data.measured_times.lastRRD >= this.props.match.params.ts &&
                    data.measured_times.next_measured == 99999999960) ||
                  this.props.match.params.ts >
                    this.getAppContext().momentjs().unix()
                ) {
                  this._autorefresh = setTimeout(() => {
                    this.loadMeasureResults();
                  }, 120000);
                } else if (
                  (data.measured_times &&
                    data.measured_times.lastRRD < this.props.match.params.ts &&
                    data.measured_times.next_measured != 99999999960) ||
                  (this.props.match.params.ts <
                    this.getAppContext().momentjs().unix() &&
                    this._autorefresh != null)
                ) {
                  clearTimeout(this._autorefresh);
                }
              },
            );
          },
        });
      },
    );
  }

  viewStep(data) {
    // if (this.getAppContext().isCloud()) {
    //   window.open("/web/stepviewer?data=" + encodeURIComponent(JSON.stringify(data)));
    // } else {
    //   window.open("/stepviewer?data=" + encodeURIComponent(JSON.stringify(data)));
    // }

    window.open(
      this.getAppContext().conf.BASENAME +
        "/stepviewer?data=" +
        encodeURIComponent(JSON.stringify(data)),
    );
  }

  downloadPcap(bssid, pcap) {
    this.setState(
      {
        loading_dlpacp: true,
      },
      () => {
        this.apiStore.fire("download_pcap", {
          filename: pcap,
          data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: bssid,
            pcap: pcap,
          },
        });
      },
    );
  }

  downloadHar(bssid, har) {
    this.setState(
      {
        loading_dlhar: true,
      },
      () => {
        this.apiStore.fire("download_har", {
          filename: har,
          data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: bssid,
            har: har,
            viewer: "no",
            token: this.getAppContext().authHandler.getToken(),
          },
        });
      },
    );
  }

  viewHar(bssid, har, viewer) {
    window.open(
      this.getAppContext().getApiStoreService().getCluster() +
        "/harviewer/preview.php?inputUrl=" +
        encodeURIComponent(
          this.getAppContext().getApiStoreService().getCluster() +
            this.getAppContext().conf.API_PATH +
            "/utils/dlhar/" +
            this.props.match.params.probeuid +
            "/" +
            this.props.match.params.measureid +
            "/" +
            bssid +
            "/" +
            har +
            "/yes?token=" +
            this.getAppContext().authHandler.getToken(),
        ) +
        "&expand=true",
    );
  }

  viewLogcat(bssid, logcat) {
    window.open(
      this.getAppContext().conf.SERVER_URL +
        `${this.getAppContext().conf.BASENAME}/logcat?log=` +
        encodeURIComponent(
          this.getAppContext().getApiStoreService().getCluster() +
            this.getAppContext().conf.API_PATH +
            "/utils/chromescreenstream/" +
            this.props.match.params.probeuid +
            "/" +
            this.props.match.params.measureid +
            "/" +
            bssid +
            "/" +
            logcat +
            "?token=" +
            this.getAppContext().authHandler.getToken(),
        ),
    );
  }

  downloadScreenshot(bssid, screenshot) {
    this.setState(
      {
        loading_dlscreenshot: true,
      },
      () => {
        this.apiStore.fire("download_screenshot", {
          filename: screenshot,
          data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: bssid,
            screenshot: screenshot,
          },
        });
      },
    );
  }

  handleClickVideo() {
    this.setState(
      {
        disableVideoBtn: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            disableVideoBtn: false,
          });
        }, 4000);
      },
    );
  }

  onComponentWillUnmount() {
    if (this._autorefresh != null) {
      clearTimeout(this._autorefresh);
    }
  }

  onRender() {
    if (
      this._resultsDataCache[this.props.match.params.ts] &&
      this.props.match.params.ts != this.state._curr_ts
    ) {
      this.setState(
        {
          data: this._resultsDataCache[this.props.match.params.ts],
          _curr_ts: this.props.match.params.ts,
        },
        () => {
          this.onClick();
        },
      );
      this._notes_editing_ctrl.setTs(this.props.match.params.ts);
      this._notes_editing_ctrl.getNotes();
    }
    if (
      !this._resultsDataCache[this.props.match.params.ts] &&
      !this.state.loading
    ) {
      this.loadMeasureResults();
    }
    return (
      <Section designType="wide">
        <Section
          designType="wide"
          className="mb-4 border-bottom border-3 border-gray300"
        >
          {(() => {
            this._measureInfo = {};
            if (this.state.data) {
              this._measureInfo = {
                name: this.state.data.name,
                essid: this.state.data.essid,
                archived: this.state.data.archived,
                paused: this.state.data.paused,
                connection_criteria: this.state.data.connection_criteria,
                test: this.state.data.test,
              };
            }
            return (
              <div
                className={
                  "px-4 pt-4 pb-3" +
                  (this.getAppContext().media.isMobile ||
                  this.getAppContext().media.isTablet
                    ? ""
                    : " d-flex")
                }
              >
                <div>
                  <h2>
                    {this._measureInfo.name ? (
                      <span>
                        <a
                          className="text-dark text-decoration-none"
                          href={`${this.getAppContext().conf.BASENAME}/${this.props.match.params.probeuid}/active/${this.props.match.params.measureid}`}
                        >
                          {this._measureInfo.name}
                        </a>
                        {!this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet ? (
                          <span className="icon-navigate-next align-middle mx-1" />
                        ) : (
                          <br />
                        )}
                        <a
                          className="text-dark text-decoration-none"
                          href={`${this.getAppContext().conf.BASENAME}/${this.props.match.params.probeuid}/active/${this.props.match.params.measureid}/overal`}
                        >
                          Overall chart
                        </a>
                        {!this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet ? (
                          <span className="icon-navigate-next align-middle mx-1" />
                        ) : (
                          <br />
                        )}
                        <span className="text-gray600">Results</span>
                      </span>
                    ) : (
                      "-"
                    )}
                  </h2>
                  <small className="text-left d-flex align-items-center mt-2">
                    <Section
                      className={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                          ? "flex-grow-1"
                          : ""
                      }
                      designType="wide"
                      layoutManager="grid"
                      elementsPerRow={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                          ? 1
                          : 5
                      }
                      gridSpacing={1}
                      gridSpacingColor={this.getAppContext().colors.gray300}
                    >
                      <div
                        className={
                          "flex-shrink-1 py-1" +
                          (!this.getAppContext().media.isMobile ||
                          this.getAppContext().media.isTablet
                            ? " px-2"
                            : "")
                        }
                      >
                        <strong className="sub-title">NETWORK:</strong>
                        <strong className="pl-2">
                          <span className="text-nowrap">
                            {this._measureInfo.essid || "-"}
                          </span>
                        </strong>
                      </div>
                      <div
                        className={
                          "flex-shrink-1 py-1" +
                          (!this.getAppContext().media.isMobile ||
                          this.getAppContext().media.isTablet
                            ? " px-2"
                            : "")
                        }
                      >
                        <strong className="text-muted text-nowrap">
                          CONNECTION CRITERIA:
                        </strong>
                        <strong className="pl-2">
                          <span
                            id={
                              typeof this._measureInfo.connection_criteria ==
                              "object"
                                ? "_tooltip_multi_ap_conn_crit_"
                                : null
                            }
                          >
                            {typeof this._measureInfo.connection_criteria ==
                            "object" ? (
                              <span className="text-nowrap">
                                Multi AP
                                <ReactOTooltip
                                  placement="bottom"
                                  target="_tooltip_multi_ap_conn_crit_"
                                  text={Object.keys(
                                    this._measureInfo.connection_criteria,
                                  ).map((_C_bssid, _C_idx) => {
                                    return (
                                      <div key={_C_idx} className="text-nowrap">
                                        <strong>{_C_bssid}</strong>
                                        {this._measureInfo.connection_criteria[
                                          _C_bssid
                                        ] ? (
                                          <span className="text-muted ml-2">
                                            (
                                            {this._measureInfo
                                              .connection_criteria[_C_bssid]
                                              .ap_custom_data
                                              ? this._measureInfo
                                                  .connection_criteria[_C_bssid]
                                                  .ap_custom_data.name
                                              : this._measureInfo
                                                  .connection_criteria[_C_bssid]
                                                  .short_desc}
                                            )
                                          </span>
                                        ) : null}
                                      </div>
                                    );
                                  })}
                                />
                                <span className="sub-title icon-info ml-2" />
                              </span>
                            ) : this._measureInfo.connection_criteria ? (
                              <span className="text-nowrap">
                                {this._measureInfo.connection_criteria}
                              </span>
                            ) : (
                              "-"
                            )}
                          </span>
                        </strong>
                      </div>
                      <div
                        className={
                          "flex-shrink-1 py-1" +
                          (!this.getAppContext().media.isMobile ||
                          this.getAppContext().media.isTablet
                            ? " px-2"
                            : "")
                        }
                      >
                        <strong className="sub-title">TEST:</strong>
                        <strong className="pl-2">
                          <span className="text-nowrap">
                            {this._measureInfo.test || "-"}
                          </span>
                        </strong>
                      </div>
                      {this.props.match.params.status == "paused" ? (
                        <div
                          className={
                            "flex-shrink-1 py-1 border-right border-gray300 text-orange text-nowrap" +
                            (!this.getAppContext().media.isMobile ||
                            this.getAppContext().media.isTablet
                              ? " px-2"
                              : "")
                          }
                        >
                          <strong className="">
                            <span className="icon-pause mr-2" />
                            PAUSED AT:
                          </strong>
                          <strong className="pl-2">
                            <span className="text-nowrap">
                              {this._measureInfo.paused
                                ? this.getAppContext()
                                    .momentjs(this._measureInfo.paused, "X")
                                    .format("L LT")
                                : "-"}
                            </span>
                          </strong>
                        </div>
                      ) : this.props.match.params.status == "archived" ? (
                        <div
                          className={
                            "flex-shrink-1 py-1 border-right border-gray300 text-orange text-nowrap" +
                            (!this.getAppContext().media.isMobile ||
                            this.getAppContext().media.isTablet
                              ? " px-2"
                              : "")
                          }
                        >
                          <strong className="">
                            <span className="icon-archive mr-2" />
                            ARCHIVED AT:
                          </strong>
                          <strong className="pl-2">
                            <span className="text-nowrap">
                              {this._measureInfo.archived
                                ? this.getAppContext()
                                    .momentjs(this._measureInfo.archived, "X")
                                    .format("L LT")
                                : "-"}
                            </span>
                          </strong>
                        </div>
                      ) : null}
                      <div className="flex-grow-1 h-100 d-flex align-items-center">
                        <ReactOActionBar padding="0">
                          <LinkContainer
                            to={{
                              pathname:
                                "/" +
                                this.props.match.params.probeuid +
                                "/config/" +
                                this.props.match.params.measureid,
                              state: { prevPath: window.location.pathname },
                            }}
                            activeClassName=""
                          >
                            <ReactOButton
                              key={1}
                              icon={
                                this.state.conf_set &&
                                this.state.conf_set.measures_conf
                                  ? this.state.conf_set.measures_conf == "SD"
                                    ? "eye-lateral"
                                    : "pencil"
                                  : ""
                              }
                              color="white"
                              title={
                                this.state.conf_set &&
                                this.state.conf_set.measures_conf
                                  ? this.state.conf_set.measures_conf == "SD"
                                    ? "View"
                                    : "Modify"
                                  : ""
                              }
                              size="sm"
                              onClick={() => {}}
                            />
                          </LinkContainer>
                        </ReactOActionBar>
                      </div>
                    </Section>
                  </small>
                </div>
              </div>
            );
          })()}
        </Section>
        <Section className="mx-4 mb-3" designType="wide">
          {!this.getAppContext().media.customWidth ? (
            <Row>
              {/* {console.log("rrd_step", this.state.rrd_step)} */}
              {this.state.rrd_step != 14400 && (
                <Col className="mb-2 mb-lg-0" lg={3}>
                  <ReactOActionBar padding="0" alignV="start">
                    {/* start meas */}
                    {this.state.data &&
                    this.state.data.measured_times &&
                    this.state.data.measured_times.prev_measured &&
                    this.state.data.measured_times.prev_measured > 0 &&
                    this.state.data.measured_times.prev_measured <
                      99999999960 ? (
                      <LinkContainer
                        to={
                          "/" +
                          this.props.match.params.probeuid +
                          "/" +
                          this.props.match.params.status +
                          "/" +
                          this.props.match.params.measureid +
                          "/" +
                          this.props.match.params.bssid +
                          "/results/" +
                          parseInt(
                            this.state.data.measured_times.prev_measured,
                          ) +
                          "/i"
                        }
                        activeClassName=""
                      >
                        <ReactOButton
                          className="h-100"
                          color="secondary"
                          icon="navigate-prev"
                          title={`Go to previous detail for measure (${this.getAppContext()
                            .momentjs(
                              this.state.data.measured_times.prev_measured,
                              "X",
                            )
                            .format("L LT")})`}
                          outline
                          disabled={
                            !this.state.data.measureData ||
                            this.getAppContext().handleTSLimit(
                              this.props.match.params.ts,
                            ).outOfLimit
                          }
                        >
                          Prev measure
                        </ReactOButton>
                      </LinkContainer>
                    ) : (
                      <ReactOButton
                        className="h-100"
                        color="secondary"
                        icon="navigate-prev"
                        outline
                        disabled
                      >
                        Prev measure
                      </ReactOButton>
                    )}
                    {this.state.data &&
                    this.state.data.measured_times &&
                    this.state.data.measured_times.next_measured &&
                    this.state.data.measured_times.next_measured > 0 &&
                    this.state.data.measured_times.next_measured <
                      99999999960 ? (
                      <LinkContainer
                        to={
                          "/" +
                          this.props.match.params.probeuid +
                          "/" +
                          this.props.match.params.status +
                          "/" +
                          this.props.match.params.measureid +
                          "/" +
                          this.props.match.params.bssid +
                          "/results/" +
                          parseInt(
                            this.state.data.measured_times.next_measured,
                          ) +
                          "/i"
                        }
                        activeClassName=""
                      >
                        <ReactOButton
                          className="h-100"
                          color="secondary"
                          iconRight
                          outline
                          icon="navigate-next"
                          title={`Go to next detail for measure (${this.getAppContext()
                            .momentjs(
                              this.state.data.measured_times.next_measured,
                              "X",
                            )
                            .format("L LT")})`}
                          disabled={
                            !this.state.data.measureData ||
                            this.getAppContext().handleTSLimit(
                              this.props.match.params.ts,
                            ).outOfLimit
                          }
                        >
                          Next measure
                        </ReactOButton>
                      </LinkContainer>
                    ) : (
                      <ReactOButton
                        className="h-100"
                        color="secondary"
                        iconRight
                        outline
                        icon="navigate-next"
                        disabled
                      >
                        Next measure
                      </ReactOButton>
                    )}
                  </ReactOActionBar>
                </Col>
              )}
              <Col
                style={
                  this.state.rrd_step != 14400 ? { marginLeft: "-7px" } : {}
                }
                sm={3}
                xs={3}
              >
                <ReactOActionBar padding="0" alignV="start">
                  <LinkContainer
                    to={
                      "/" +
                      this.props.match.params.probeuid +
                      "/" +
                      this.props.match.params.status +
                      "/" +
                      this.props.match.params.measureid +
                      "/" +
                      this.props.match.params.bssid +
                      "/results/" +
                      (parseInt(this.props.match.params.ts) -
                        (this.state.data.measureData
                          ? this.state.data.measureData.rrd_step
                          : 0)) +
                      "/i"
                    }
                    activeClassName=""
                  >
                    <ReactOButton
                      className="h-100"
                      color="secondary"
                      outline
                      icon="navigate-prev"
                      disabled={
                        this.getAppContext().momentjs().unix() -
                          this.props.match.params.ts <
                          -59 ||
                        !this.state.data.measureData ||
                        this.getAppContext().handleTSLimit(
                          this.props.match.params.ts,
                        ).outOfLimit
                      }
                    >
                      {this.state.rrd_step != 14400 ? "- 1 min" : "- 4 hours"}
                    </ReactOButton>
                  </LinkContainer>
                  <LinkContainer
                    to={
                      "/" +
                      this.props.match.params.probeuid +
                      "/" +
                      this.props.match.params.status +
                      "/" +
                      this.props.match.params.measureid +
                      "/" +
                      this.props.match.params.bssid +
                      "/results/" +
                      (parseInt(this.props.match.params.ts) +
                        (this.state.data.measureData
                          ? this.state.data.measureData.rrd_step
                          : 0)) +
                      "/i"
                    }
                    activeClassName=""
                  >
                    <ReactOButton
                      className="h-100"
                      color="secondary"
                      outline
                      iconRight
                      icon="navigate-next"
                      disabled={
                        this.props.match.params.ts >
                          this.getAppContext().momentjs().unix() ||
                        !this.state.data.measureData ||
                        this.getAppContext().handleTSLimit(
                          this.props.match.params.ts,
                        ).outOfLimit
                      }
                    >
                      {this.state.rrd_step != 14400 ? "+ 1 min" : "+ 4 hours"}
                    </ReactOButton>
                  </LinkContainer>
                </ReactOActionBar>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col className="mb-2 mb-lg-0">
                <ReactOActionBar padding="0" alignV="start">
                  {/* start meas */}
                  {this.state.data &&
                  this.state.data.measured_times &&
                  this.state.data.measured_times.prev_measured &&
                  this.state.data.measured_times.prev_measured > 0 &&
                  this.state.data.measured_times.prev_measured < 99999999960 ? (
                    <LinkContainer
                      to={
                        "/" +
                        this.props.match.params.probeuid +
                        "/" +
                        this.props.match.params.status +
                        "/" +
                        this.props.match.params.measureid +
                        "/" +
                        this.props.match.params.bssid +
                        "/results/" +
                        parseInt(this.state.data.measured_times.prev_measured) +
                        "/i"
                      }
                      activeClassName=""
                    >
                      <ReactOButton
                        className="h-100"
                        color="secondary"
                        icon="navigate-prev"
                        title={`Go to previous detail for measure (${this.getAppContext()
                          .momentjs(
                            this.state.data.measured_times.prev_measured,
                            "X",
                          )
                          .format("L LT")})`}
                        outline
                        disabled={
                          !this.state.data.measureData ||
                          this.getAppContext().handleTSLimit(
                            this.props.match.params.ts,
                          ).outOfLimit
                        }
                      >
                        Prev measure
                      </ReactOButton>
                    </LinkContainer>
                  ) : (
                    <ReactOButton
                      className="h-100"
                      color="secondary"
                      icon="navigate-prev"
                      outline
                      disabled
                    >
                      Prev measure
                    </ReactOButton>
                  )}
                  {this.state.data &&
                  this.state.data.measured_times &&
                  this.state.data.measured_times.next_measured &&
                  this.state.data.measured_times.next_measured > 0 &&
                  this.state.data.measured_times.next_measured < 99999999960 ? (
                    <LinkContainer
                      to={
                        "/" +
                        this.props.match.params.probeuid +
                        "/" +
                        this.props.match.params.status +
                        "/" +
                        this.props.match.params.measureid +
                        "/" +
                        this.props.match.params.bssid +
                        "/results/" +
                        parseInt(this.state.data.measured_times.next_measured) +
                        "/i"
                      }
                      activeClassName=""
                    >
                      <ReactOButton
                        className="h-100"
                        color="secondary"
                        iconRight
                        outline
                        icon="navigate-next"
                        title={`Go to next detail for measure (${this.getAppContext()
                          .momentjs(
                            this.state.data.measured_times.next_measured,
                            "X",
                          )
                          .format("L LT")})`}
                        disabled={
                          !this.state.data.measureData ||
                          this.getAppContext().handleTSLimit(
                            this.props.match.params.ts,
                          ).outOfLimit
                        }
                      >
                        Next measure
                      </ReactOButton>
                    </LinkContainer>
                  ) : (
                    <ReactOButton
                      className="h-100"
                      color="secondary"
                      iconRight
                      outline
                      icon="navigate-next"
                      disabled
                    >
                      Next measure
                    </ReactOButton>
                  )}

                  <span className="margin-top-buttons dynamic-margin-left">
                    <LinkContainer
                      to={
                        "/" +
                        this.props.match.params.probeuid +
                        "/" +
                        this.props.match.params.status +
                        "/" +
                        this.props.match.params.measureid +
                        "/" +
                        this.props.match.params.bssid +
                        "/results/" +
                        (parseInt(this.props.match.params.ts) -
                          (this.state.data.measureData
                            ? this.state.data.measureData.rrd_step
                            : 0)) +
                        "/i"
                      }
                      activeClassName=""
                    >
                      <ReactOButton
                        className="h-100"
                        color="secondary"
                        outline
                        icon="navigate-prev"
                        disabled={
                          this.getAppContext().momentjs().unix() -
                            this.props.match.params.ts <
                            -59 ||
                          !this.state.data.measureData ||
                          this.getAppContext().handleTSLimit(
                            this.props.match.params.ts,
                          ).outOfLimit
                        }
                      >
                        - 1 min
                      </ReactOButton>
                    </LinkContainer>
                    <LinkContainer
                      to={
                        "/" +
                        this.props.match.params.probeuid +
                        "/" +
                        this.props.match.params.status +
                        "/" +
                        this.props.match.params.measureid +
                        "/" +
                        this.props.match.params.bssid +
                        "/results/" +
                        (parseInt(this.props.match.params.ts) +
                          (this.state.data.measureData
                            ? this.state.data.measureData.rrd_step
                            : 0)) +
                        "/i"
                      }
                      activeClassName=""
                    >
                      <ReactOButton
                        className="h-100 ml-05"
                        color="secondary"
                        outline
                        iconRight
                        icon="navigate-next"
                        disabled={
                          this.props.match.params.ts >
                            this.getAppContext().momentjs().unix() ||
                          !this.state.data.measureData ||
                          this.getAppContext().handleTSLimit(
                            this.props.match.params.ts,
                          ).outOfLimit
                        }
                      >
                        + 1 min
                      </ReactOButton>
                    </LinkContainer>
                  </span>
                </ReactOActionBar>
              </Col>
            </Row>
          )}
        </Section>

        <Section designType="wide" className="mx-4 mb-3">
          <Panel rounded bodyClassName="p-0">
            <_LoadingWrapper
              minHeight
              loadingPlug={this.state.loading || this.state.loading_notes}
            >
              {!this.getAppContext().handleTSLimit(this.props.match.params.ts)
                .outOfLimit ? (
                this.state.data.measureData ? (
                  <div>
                    {this.state.data.measureResults.length == 0 &&
                    this.state.data.measureData.rssi != 0 ? (
                      <div>
                        <Row noGutters>
                          <Col
                            xs={12}
                            md={
                              this.state.data.overlap &&
                              this.state.data.overlap.reference
                                ? 9
                                : 12
                            }
                            className="border-right border-gray300"
                          >
                            <Section
                              style={{ maxWidth: "1920px !important" }}
                              layoutManager="grid"
                              elementsPerRow={
                                this.getAppContext().media.isMobile ||
                                this.getAppContext().media.isTablet
                                  ? 1
                                  : this.state.data.measureData.rrd_step > 60
                                    ? 3
                                    : 3
                              }
                              gridSpacing={1}
                              gridSpacingColor={
                                this.getAppContext().colors.gray300
                              }
                            >
                              {this.state.data.measureData.rrd_step > 60
                                ? [
                                    ...[
                                      <div className="d-flex flex-column p-3">
                                        <div className="sub-title mb-2">
                                          <strong>DATETIME</strong>
                                        </div>
                                        <div className="d-flex h-100 align-items-center title-3">
                                          <strong>
                                            {this.getAppContext()
                                              .momentjs(
                                                this.props.match.params.ts,
                                                "X",
                                              )
                                              .format("L LT")}{" "}
                                            -{" "}
                                            {this.getAppContext()
                                              .momentjs(
                                                parseInt(
                                                  this.props.match.params.ts,
                                                ) +
                                                  this.state.data.measureData
                                                    .rrd_step,
                                                "X",
                                              )
                                              .format("L LT")}
                                          </strong>
                                        </div>
                                      </div>,
                                    ],
                                    ...(this.getAppContext().media.isMobile ||
                                    this.getAppContext().media.isTablet
                                      ? [<div />]
                                      : []),
                                  ]
                                : [
                                    <div
                                      key={1}
                                      className="d-flex flex-column p-3"
                                    >
                                      <div className="sub-title mb-2">
                                        <strong>DATE</strong>
                                      </div>
                                      <div className="d-flex h-100 align-items-center title-3">
                                        <strong>
                                          {this.getAppContext()
                                            .momentjs(
                                              this.props.match.params.ts,
                                              "X",
                                            )
                                            .format("L")}
                                        </strong>
                                      </div>
                                    </div>,
                                    <div
                                      key={2}
                                      className="d-flex flex-column p-3"
                                    >
                                      <div className="sub-title mb-2">
                                        <strong>ON MINUTE</strong>
                                      </div>
                                      <div className="d-flex h-100 align-items-center title-3">
                                        <strong>
                                          {this.getAppContext()
                                            .momentjs(
                                              this.props.match.params.ts,
                                              "X",
                                            )
                                            .format("LT")}
                                        </strong>
                                      </div>
                                    </div>,
                                  ]}
                              {/*  */}
                              {this.state.data.overlap &&
                              this.state.data.overlap.reference ? (
                                <div className="d-flex flex-column p-3">
                                  <div className="sub-title mb-2">
                                    <strong>OVERLAP INDEX</strong>
                                  </div>
                                  <div className="d-flex h-100 align-items-center title-3">
                                    <strong>
                                      {this.state.data.overlap.overlap_index
                                        ? this.state.data.overlap
                                            .overlap_index > 100 &&
                                          this.state.data.overlap
                                            .overlap_index < 200
                                          ? "> 100"
                                          : this.state.data.overlap
                                                .overlap_index > 200
                                            ? ">> 100"
                                            : this.state.data.overlap
                                                .overlap_index
                                        : "-"}
                                    </strong>
                                  </div>
                                </div>
                              ) : null}

                              {this.state.data.overlap &&
                              this.state.data.overlap.reference ? (
                                <div className="d-flex flex-column p-3">
                                  <div className="sub-title mb-2">
                                    <span className="icon-router mr-2" />
                                    <strong>BSSID</strong>
                                  </div>
                                  <div className="d-flex h-100 align-items-center title-3">
                                    <strong>
                                      {this.state.data.overlap.reference.bssid}
                                    </strong>
                                  </div>
                                  <div className="sub-title">
                                    <span id="_tl_lan-mac">
                                      {this.state.data.measureData.bssid_info
                                        .ap_custom_data
                                        ? this.state.data.measureData.bssid_info
                                            .ap_custom_data.name
                                        : this.state.data.measureData.bssid_info
                                              .long_desc
                                          ? this.state.data.measureData
                                              .bssid_info.long_desc
                                          : "-"}
                                    </span>
                                    {this.state.data.measureData.bssid_info
                                      .ap_custom_data ? (
                                      <ReactOTooltip
                                        placement="bottom"
                                        target="_tl_lan-mac"
                                        text={
                                          "LAN mac address: " +
                                          this.state.data.measureData.bssid_info
                                            .ap_custom_data.mac_lan
                                        }
                                      />
                                    ) : null}
                                  </div>
                                </div>
                              ) : null}
                              {/*  */}
                              {this.state.data.measureResults.length == 0 &&
                              this.state.data.measureData.errors_count > 0 ? (
                                <div
                                  className="d-flex flex-column p-3"
                                  style={{
                                    backgroundColor: "#f5c6cb",
                                    color: "#721c24",
                                    height: "100%",
                                  }}
                                >
                                  <div className="d-flex h-100 align-items-center title-3">
                                    No measures done. <br />
                                    BSSID of ESSID not visible
                                  </div>
                                </div>
                              ) : this.state.data.measureResults.length == 0 &&
                                this.state.data.measureData.errors_count ==
                                  null ? (
                                <div
                                  className="d-flex flex-column p-3"
                                  style={{ height: "100%" }}
                                >
                                  {this.state.data.measured_times.lastRRD &&
                                  this.props.match.params.ts <
                                    this.state.data.measured_times.lastRRD &&
                                  this.state.data.measured_times
                                    .next_measured != 99999999960 ? (
                                    <div className="d-flex h-100 align-items-center title-3">
                                      <strong>
                                        No measures on the minute{" "}
                                      </strong>
                                    </div>
                                  ) : (
                                    <div className="d-flex h-100 align-items-center title-3">
                                      {this.props.match.params.ts >
                                      this.getAppContext().momentjs().unix() ? (
                                        <strong className="text-danger">
                                          Future Time
                                        </strong>
                                      ) : (
                                        <strong>Waiting for probe data</strong>
                                      )}
                                    </div>
                                  )}
                                </div>
                              ) : this.state.data.measureResults.length == 0 &&
                                this.state.data.measureData.errors_count ==
                                  0 ? (
                                <div
                                  className="d-flex flex-column p-3"
                                  style={{ height: "100%" }}
                                >
                                  {this.state.data.measured_times.lastRRD &&
                                  this.props.match.params.ts <
                                    this.state.data.measured_times.lastRRD &&
                                  this.state.data.measured_times
                                    .next_measured != 99999999960 ? (
                                    <div className="d-flex h-100 align-items-center title-3">
                                      <strong>
                                        No measures on the minute <br />
                                        Out of connection criteria
                                      </strong>
                                    </div>
                                  ) : (
                                    <div className="d-flex h-100 align-items-center title-3">
                                      {this.props.match.params.ts >
                                      this.getAppContext().momentjs().unix() ? (
                                        <strong className="text-danger">
                                          Future Time
                                        </strong>
                                      ) : (
                                        <strong>Waiting for probe data</strong>
                                      )}
                                    </div>
                                  )}
                                </div>
                              ) : null}
                              {/*  */}
                              {this.state.data.overlap &&
                              this.state.data.overlap.reference ? (
                                <div className="d-flex flex-column p-3">
                                  <div className="sub-title mb-2">
                                    <strong>FREQUENCY</strong>
                                  </div>
                                  <div className="d-flex h-100 align-items-center title-3">
                                    <strong>
                                      {
                                        this.state.data.overlap.reference
                                          .bw_carrier
                                      }{" "}
                                      MHz
                                    </strong>
                                  </div>
                                </div>
                              ) : null}
                            </Section>
                          </Col>

                          {this.state.data.overlap &&
                          this.state.data.overlap.reference
                            ? (() => {
                                let overlaps = {
                                  ...this.state.data.overlap.overlaps,
                                };
                                let overlappingBw = [
                                  ...this.state.data.overlap.overlapping,
                                ];
                                let reference = {
                                  ...this.state.data.overlap.reference,
                                };
                                let filterdBssid = [];

                                Object.keys(overlaps).forEach((bssid, id) => {
                                  let filteredOverlaps = overlappingBw.find(
                                    (elem) => {
                                      return (
                                        elem.bssid_orig == bssid &&
                                        overlaps[bssid].rssi == elem.rssi
                                      );
                                    },
                                  );
                                  // console.log("bssid:", bssid, overlaps[bssid]);
                                  // console.log("filteredOverlaps", filteredOverlaps);
                                  // let max = Math.max(...filteredOverlaps.map((item) => item.rssi));
                                  // let result = filteredOverlaps.filter((item) => item.rssi === max);
                                  Array.prototype.push.apply(filterdBssid, [
                                    filteredOverlaps,
                                  ]);
                                });

                                // occurrences for table hover tooltip
                                const occurrences = [
                                  ...[reference],
                                  ...overlappingBw,
                                ].reduce(function (acc, { bssid_orig }) {
                                  return (
                                    acc[bssid_orig]
                                      ? ++acc[bssid_orig]
                                      : (acc[bssid_orig] = 1),
                                    acc
                                  );
                                }, {});

                                let overlapData = {
                                  ...this.state.data.overlap,
                                };

                                overlapData = {
                                  ...overlapData,
                                  filterdBssid: filterdBssid,
                                  occurrences: occurrences,
                                };

                                return (
                                  <Col xs={12} md={3}>
                                    <div className="d-flex flex-column align-self-center p-3 bg-gray150 h-100">
                                      <div className="d-flex mb-2">
                                        <div className="sub-title flex-grow-1">
                                          <strong className="mr-3">
                                            OVERLAP GRAPH
                                          </strong>
                                        </div>
                                        <div>
                                          <ReactOButton
                                            outline
                                            size="sm"
                                            onClick={() => {
                                              this._overlap_modal.open({
                                                ...overlapData,
                                                ...{
                                                  ts: this.props.match.params
                                                    .ts,
                                                },
                                              });
                                            }}
                                          >
                                            More
                                          </ReactOButton>
                                        </div>
                                      </div>
                                      <div
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          this._overlap_modal.open({
                                            ...overlapData,
                                            ...{
                                              ts: this.props.match.params.ts,
                                            },
                                          });
                                        }}
                                      >
                                        <BandwidthOverlapChart
                                          data={overlapData}
                                          showBeacon={true}
                                          aspectRatio={2}
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                );
                              })()
                            : null}
                        </Row>
                      </div>
                    ) : this.state.data.measureResults.length == 0 ? (
                      <Section
                        className="flex-grow-1"
                        designType="wide"
                        layoutManager="grid"
                        elementsPerRow={
                          this.getAppContext().media.isMobile ||
                          this.getAppContext().media.isTablet
                            ? 1
                            : this.state.data.measureData.rrd_step > 60
                              ? 3
                              : 3
                        }
                        gridSpacing={1}
                        gridSpacingColor={this.getAppContext().colors.gray300}
                      >
                        {this.state.data.measureData.rrd_step > 60
                          ? [
                              ...[
                                <div className="d-flex flex-column p-3">
                                  <div className="sub-title mb-2">
                                    <strong>DATETIME</strong>
                                  </div>
                                  <div className="d-flex h-100 align-items-center title-3">
                                    <strong>
                                      {this.getAppContext()
                                        .momentjs(
                                          this.props.match.params.ts,
                                          "X",
                                        )
                                        .format("L LT")}{" "}
                                      -{" "}
                                      {this.getAppContext()
                                        .momentjs(
                                          parseInt(this.props.match.params.ts) +
                                            this.state.data.measureData
                                              .rrd_step,
                                          "X",
                                        )
                                        .format("L LT")}
                                    </strong>
                                  </div>
                                </div>,
                              ],
                              ...(this.getAppContext().media.isMobile ||
                              this.getAppContext().media.isTablet
                                ? [<div />]
                                : []),
                            ]
                          : [
                              <div key={1} className="d-flex flex-column p-3">
                                <div className="sub-title mb-2">
                                  <strong>DATE</strong>
                                </div>
                                <div className="d-flex h-100 align-items-center title-3">
                                  <strong>
                                    {this.getAppContext()
                                      .momentjs(this.props.match.params.ts, "X")
                                      .format("L")}
                                  </strong>
                                </div>
                              </div>,
                              <div key={2} className="d-flex flex-column p-3">
                                <div className="sub-title mb-2">
                                  <strong>ON MINUTE</strong>
                                </div>
                                <div
                                  className={
                                    "d-flex h-100 align-items-center title-3"
                                  }
                                >
                                  <strong>
                                    {this.getAppContext()
                                      .momentjs(this.props.match.params.ts, "X")
                                      .format("LT")}{" "}
                                  </strong>
                                </div>
                              </div>,
                            ]}
                        {this.state.data.measureResults.length == 0 &&
                        this.state.data.measureData.errors_count > 0 ? (
                          <div
                            className="d-flex flex-column p-3"
                            style={{
                              backgroundColor: "#f5c6cb",
                              color: "#721c24",
                              height: "100%",
                            }}
                          >
                            <div className="d-flex h-100 align-items-center title-3">
                              No measures done. <br />
                              BSSID of ESSID not visible
                            </div>
                          </div>
                        ) : this.state.data.measureResults.length == 0 &&
                          this.state.data.measureData.errors_count == null ? (
                          <div
                            className="d-flex flex-column p-3"
                            style={{ height: "100%" }}
                          >
                            {this.state.data.measured_times &&
                            this.state.data.measured_times.lastRRD &&
                            this.props.match.params.ts <
                              this.state.data.measured_times.lastRRD &&
                            this.state.data.measured_times.next_measured !=
                              99999999960 ? (
                              <div className="d-flex h-100 align-items-center title-3">
                                <strong>No measures on the minute </strong>
                              </div>
                            ) : (
                              <div className="d-flex h-100 align-items-center title-3">
                                {this.props.match.params.ts >
                                this.getAppContext().momentjs().unix() ? (
                                  <strong className="text-danger">
                                    Future Time
                                  </strong>
                                ) : (
                                  <strong>Waiting for probe data</strong>
                                )}
                              </div>
                            )}
                          </div>
                        ) : this.state.data.measureResults.length == 0 &&
                          this.state.data.measureData.errors_count == 0 ? (
                          <div
                            className="d-flex flex-column p-3"
                            style={{ height: "100%" }}
                          >
                            {this.state.data.measured_times.lastRRD &&
                            this.props.match.params.ts <
                              this.state.data.measured_times.lastRRD &&
                            this.state.data.measured_times.next_measured !=
                              99999999960 ? (
                              <div className="d-flex h-100 align-items-center title-3">
                                <strong>
                                  No measures on the minute <br />
                                  Out of connection criteria
                                </strong>
                              </div>
                            ) : (
                              <div className="d-flex h-100 align-items-center title-3">
                                {this.props.match.params.ts >
                                this.getAppContext().momentjs().unix() ? (
                                  <strong className="text-danger">
                                    Future Time
                                  </strong>
                                ) : (
                                  <strong>Waiting for probe data</strong>
                                )}
                              </div>
                            )}
                          </div>
                        ) : null}
                      </Section>
                    ) : (
                      <Section
                        className="flex-grow-1"
                        designType="wide"
                        layoutManager="grid"
                        elementsPerRow={
                          this.getAppContext().media.isMobile ||
                          this.getAppContext().media.isTablet
                            ? 2
                            : this.state.data.measureData.rrd_step > 60
                              ? 3
                              : 4
                        }
                        gridSpacing={1}
                        gridSpacingColor={this.getAppContext().colors.gray300}
                      >
                        {this.state.data.measureData.rrd_step > 60
                          ? [
                              ...[
                                <div className="d-flex flex-column p-3">
                                  <div className="sub-title mb-2">
                                    <strong>DATETIME</strong>
                                  </div>
                                  <div className="d-flex h-100 align-items-center title-3">
                                    <strong>
                                      {this.getAppContext()
                                        .momentjs(
                                          this.props.match.params.ts,
                                          "X",
                                        )
                                        .format("L LT")}{" "}
                                      -{" "}
                                      {this.getAppContext()
                                        .momentjs(
                                          parseInt(this.props.match.params.ts) +
                                            this.state.data.measureData
                                              .rrd_step,
                                          "X",
                                        )
                                        .format("L LT")}
                                    </strong>
                                  </div>
                                </div>,
                              ],
                              ...(this.getAppContext().media.isMobile ||
                              this.getAppContext().media.isTablet
                                ? [<div />]
                                : []),
                            ]
                          : [
                              <div key={1} className="d-flex flex-column p-3">
                                <div className="sub-title mb-2">
                                  <strong>DATE</strong>
                                </div>
                                <div className="d-flex h-100 align-items-center title-3">
                                  <strong>
                                    {this.getAppContext()
                                      .momentjs(this.props.match.params.ts, "X")
                                      .format("L")}
                                  </strong>
                                </div>
                              </div>,
                              <div key={2} className="d-flex flex-column p-3">
                                <div className="sub-title mb-2">
                                  <strong>ON MINUTE</strong>
                                </div>
                                <div
                                  className={
                                    "d-flex h-100 align-items-center title-3"
                                  }
                                >
                                  <strong>
                                    {this.getAppContext()
                                      .momentjs(this.props.match.params.ts, "X")
                                      .format("LT")}
                                  </strong>
                                </div>
                              </div>,
                            ]}
                        <div className="d-flex flex-column p-3">
                          <div className="sub-title mb-2">
                            <strong>ERRORS COUNT</strong>
                          </div>
                          <div className="d-flex h-100 align-items-center title-3 text-danger">
                            <strong>
                              {this.state.data.measureData.errors_count}
                            </strong>
                          </div>
                        </div>
                        <div className="d-flex flex-column p-3">
                          <div className="sub-title mb-2">
                            <strong>MEASURES COUNT</strong>
                          </div>
                          <div className="d-flex h-100 align-items-center title-3">
                            <strong>
                              {this.state.data.measureResults.length}
                            </strong>
                          </div>
                        </div>
                      </Section>
                    )}

                    <Row className="px-3">
                      <Col className="px-3 py-2 border-top bg-gray150 rounded-bottom">
                        <div className="sub-title d-flex align-items-center">
                          <span className="icon-note mr-2" />
                          <strong>NOTES</strong>
                          <ReactOButton
                            className="ml-2"
                            color="secondary"
                            text
                            icon="plus-circle"
                            onClick={(e) => {
                              this._notes_editing_ctrl.createNoteAt(
                                this.props.match.params.ts,
                              );
                            }}
                          />
                        </div>
                        {this.state.notes && this.state.notes.length ? (
                          <div className="mt-2">
                            {this.state.notes.map((_C_note, _C_idx) => {
                              return (
                                <small
                                  key={_C_idx}
                                  className={
                                    "d-flex" +
                                    (_C_idx != this.state.notes.length - 1
                                      ? " border-bottom border-gray500"
                                      : "")
                                  }
                                >
                                  <div className="flex-grow-1 d-flex align-items-center">
                                    <div className="font-weight-normal text-wrap">
                                      <span>{_C_note.text}</span>
                                      <ReactOButton
                                        className="ml-2"
                                        size="sm"
                                        color="secondary"
                                        icon="pencil"
                                        text
                                        onClick={(e) => {
                                          this._notes_editing_ctrl.openEditModal(
                                            _C_note,
                                          );
                                        }}
                                      />
                                      <ReactOButton
                                        className="ml-2"
                                        size="sm"
                                        color="danger"
                                        icon="cancel"
                                        text
                                        onClick={(e) => {
                                          this._notes_editing_ctrl.openDeleteModal(
                                            _C_note,
                                          );
                                        }}
                                      />
                                    </div>
                                  </div>
                                </small>
                              );
                            })}
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                  </div>
                ) : null
              ) : (
                <div>
                  <Row noGutters>
                    <Col
                      xs={12}
                      md={12}
                      className="border-right border-gray300"
                    >
                      <Section
                        style={{ maxWidth: "1920px !important" }}
                        layoutManager="grid"
                        elementsPerRow={
                          this.getAppContext().media.isMobile ||
                          this.getAppContext().media.isTablet
                            ? 1
                            : 3
                        }
                        gridSpacing={1}
                        gridSpacingColor={this.getAppContext().colors.gray300}
                      >
                        <div className="d-flex flex-column p-3">
                          <div className="sub-title mb-2">
                            <strong>DATE</strong>
                          </div>
                          <div className="d-flex h-100 align-items-center title-3">
                            <strong>
                              {this.getAppContext()
                                .momentjs(this.props.match.params.ts, "X")
                                .format("L LT")}{" "}
                              {/* {this.getAppContext()
                                .momentjs(
                                  parseInt(this.props.match.params.ts) +
                                    this.state.data.measureData.rrd_step,
                                  "X"
                                )
                                .format("L LT")} */}
                            </strong>
                          </div>
                        </div>

                        <div className="d-flex h-100 align-items-center title-3 p-3">
                          <strong>
                            {
                              this.getAppContext().handleTSLimit(
                                this.props.match.params.ts,
                              ).infoMsg
                            }
                            {!this.getAppContext().isCloud() && (
                              <div>More data may be available on cloud</div>
                            )}
                          </strong>
                        </div>
                      </Section>
                    </Col>
                  </Row>
                </div>
              )}
            </_LoadingWrapper>
          </Panel>
        </Section>

        {!this.getAppContext().handleTSLimit(this.props.match.params.ts)
          .outOfLimit && (
          <Section designType="wide" className="mx-4 mb-3">
            <div>
              <_LoadingWrapper minHeight loadingPlug={this.state.loading}>
                {this.state.data.measureResults &&
                !this.state.loading &&
                this.state.data.measureResults.length > 0 ? (
                  (() => {
                    let _measureResultsPerBssid = {};
                    let _firstWithError = undefined;
                    let _firstErrorOfPhase = undefined;
                    this.state.data.measureResults.forEach(
                      (_CURR_measureResult, _CURR_idx) => {
                        console.log("_CURR_measureResult", _CURR_measureResult);
                        if (
                          !_measureResultsPerBssid[_CURR_measureResult.bssid]
                        ) {
                          _measureResultsPerBssid[_CURR_measureResult.bssid] =
                            [];
                        }
                        if (
                          _firstWithError === undefined &&
                          _CURR_measureResult.summary.errors > 0
                        ) {
                          _firstWithError = _CURR_idx;
                        }
                        _measureResultsPerBssid[_CURR_measureResult.bssid].push(
                          _CURR_measureResult,
                        );
                        if (
                          isNaN(this.props.match.params.resid) &&
                          this.props.match.params.resid != "i" &&
                          _firstErrorOfPhase === undefined
                        ) {
                          _CURR_measureResult.summary.steps.forEach(
                            (_C_phase, _C_idx) => {
                              if (
                                this.props.match.params.resid == _C_phase[0] &&
                                isNaN(_C_phase[1])
                              ) {
                                _firstErrorOfPhase = _CURR_idx;
                              }
                            },
                          );
                        }
                      },
                    );

                    //	if (_firstErrorOfPhase !== undefined) {
                    //		this.getAppContext().getLocalStorageService().set('coming_from_errors_index', this.props.match.params.resid);
                    //	} else {
                    //		this.getAppContext().getLocalStorageService().remove('coming_from_errors_index');
                    //	}

                    let _selectedResult = 0;
                    _selectedResult = !isNaN(this.props.match.params.resid)
                      ? this.props.match.params.resid
                      : this.props.match.params.resid != "i" &&
                          _firstErrorOfPhase !== undefined
                        ? _firstErrorOfPhase
                        : _firstWithError !== undefined
                          ? _firstWithError
                          : 0;

                    if (
                      _selectedResult >
                      this.state.data.measureResults.length - 1
                    ) {
                      _selectedResult = 0;
                    }

                    // Prepare Obj for BandwithOverlapChart and table with bssid_orig

                    let overlaps = {
                      ...this.state.data.measureResults[_selectedResult].overlap
                        .overlap_data.overlaps,
                    };
                    let overlappingBw = [
                      ...this.state.data.measureResults[_selectedResult].overlap
                        .overlap_data.overlapping,
                    ];
                    let reference = {
                      ...this.state.data.measureResults[_selectedResult].overlap
                        .overlap_data.reference,
                    };
                    let filterdBssid = [];

                    Object.keys(overlaps).forEach((bssid, id) => {
                      let filteredOverlaps = overlappingBw.find((elem) => {
                        return (
                          elem.bssid_orig == bssid &&
                          overlaps[bssid].rssi == elem.rssi
                        );
                      });
                      // console.log("bssid:", bssid, overlaps[bssid]);
                      // console.log("filteredOverlaps", filteredOverlaps);
                      // let max = Math.max(...filteredOverlaps.map((item) => item.rssi));
                      // let result = filteredOverlaps.filter((item) => item.rssi === max);
                      Array.prototype.push.apply(filterdBssid, [
                        filteredOverlaps,
                      ]);
                    });

                    // occurrences for table hover tooltip
                    const occurrences = [
                      ...[reference],
                      ...overlappingBw,
                    ].reduce(function (acc, { bssid_orig }) {
                      return (
                        acc[bssid_orig]
                          ? ++acc[bssid_orig]
                          : (acc[bssid_orig] = 1),
                        acc
                      );
                    }, {});

                    let overlapData = {
                      ...this.state.data.measureResults[_selectedResult].overlap
                        .overlap_data,
                    };

                    overlapData = {
                      ...overlapData,
                      filterdBssid: filterdBssid,
                      occurrences: occurrences,
                    };
                    // console.log("overlapdata", overlapData);

                    const { overlap_data } =
                      this.state.data.measureResults[_selectedResult].overlap ||
                      {};

                    return (
                      <Row>
                        <Col>
                          <Panel
                            className="measure-result-details-viewer"
                            bodyClassName="p-0"
                            rounded
                            header={
                              // <div>
                              //   <strong>ANALYSIS</strong>
                              // </div>
                              <Row>
                                <Col>
                                  <strong>ANALYSIS</strong>
                                </Col>
                                <Col className="d-flex justify-content-end mr-3">
                                  <ReactOButton
                                    className="text-left mr-2"
                                    size="sm"
                                    color="primary"
                                    outline
                                    onClick={() => {
                                      this.getAppContext()
                                        .getLocalStorageService()
                                        .set("results_view_mode", "list");
                                      this.viewMode = "list";
                                      this.forceUpdate();
                                    }}
                                    icon="list-2"
                                    active={this.viewMode == "list"}
                                  />
                                  <ReactOButton
                                    className="text-left"
                                    color="primary"
                                    outline
                                    size="sm"
                                    onClick={() => {
                                      this.getAppContext()
                                        .getLocalStorageService()
                                        .set("results_view_mode", "grid");
                                      this.viewMode = "grid";
                                      this.forceUpdate();
                                    }}
                                    icon="view-tile"
                                    active={this.viewMode == "grid"}
                                  />
                                </Col>
                              </Row>
                            }
                          >
                            <Row noGutters>
                              <Col
                                xs={12}
                                md={2}
                                style={
                                  !this.getAppContext().media.isMobile
                                    ? { maxWidth: "16%" }
                                    : {}
                                }
                              >
                                {(() => {
                                  let _C = -1;
                                  return (
                                    <div
                                      className={
                                        "measure-result-list h-100" +
                                        (!this.getAppContext().media.isMobile &&
                                        !this.getAppContext().media.isTablet
                                          ? " border-right border-3 border-gray300"
                                          : "")
                                      }
                                    >
                                      {Object.keys(_measureResultsPerBssid).map(
                                        (_CURR_bssid, _CURR_idx1) => {
                                          return (
                                            <div key={_CURR_idx1}>
                                              <div
                                                className={
                                                  "measure-result-list-bssid-divider" +
                                                  (_CURR_idx1 > 0 ? "" : "")
                                                }
                                              >
                                                {/ethernet/i.test(
                                                  this.state.data.essid,
                                                ) ? (
                                                  <strong>
                                                    <span className="icon-ethernet mr-2" />
                                                    ethernet
                                                  </strong>
                                                ) : (
                                                  <strong className="d-flex align-items-center">
                                                    <span className="icon-router mr-2" />
                                                    <span className="mr-2">
                                                      {_CURR_bssid}
                                                    </span>
                                                    {this.getAppContext().freqToLabel(
                                                      _measureResultsPerBssid[
                                                        _CURR_bssid
                                                      ][0].frequency,
                                                    )}
                                                  </strong>
                                                )}
                                              </div>
                                              <ListGroup flush>
                                                {_measureResultsPerBssid[
                                                  _CURR_bssid
                                                ].map(
                                                  (
                                                    _CURR_result,
                                                    _CURR_idx2,
                                                  ) => {
                                                    _C = _C + 1;
                                                    var _totalForStep = 0;
                                                    _CURR_result.summary.steps.forEach(
                                                      (val, id) => {
                                                        _totalForStep =
                                                          _totalForStep +
                                                          parseInt(val[1]);
                                                      },
                                                    );
                                                    return (
                                                      <LinkContainer
                                                        onClick={this.onClick}
                                                        key={_CURR_idx2}
                                                        to={
                                                          "/" +
                                                          this.props.match
                                                            .params.probeuid +
                                                          "/" +
                                                          this.props.match
                                                            .params.status +
                                                          "/" +
                                                          this.props.match
                                                            .params.measureid +
                                                          "/" +
                                                          this.props.match
                                                            .params.bssid +
                                                          "/results/" +
                                                          this.props.match
                                                            .params.ts +
                                                          "/" +
                                                          _C
                                                        }
                                                      >
                                                        <ListGroupItem
                                                          tag="a"
                                                          action
                                                          className={
                                                            "d-flex result-item py-3" +
                                                            (!this.getAppContext()
                                                              .media.isMobile &&
                                                            !this.getAppContext()
                                                              .media.isTablet
                                                              ? " text-right"
                                                              : " text-center")
                                                          }
                                                          active={
                                                            _selectedResult ==
                                                            _C
                                                          }
                                                          color={
                                                            _CURR_result.summary
                                                              .errors > 0
                                                              ? "danger"
                                                              : null
                                                          }
                                                        >
                                                          <strong className="flex-grow-1">
                                                            {this.getAppContext()
                                                              .momentjs(
                                                                _CURR_result.etime,
                                                                "X",
                                                              )
                                                              .format("LTS")}
                                                          </strong>
                                                          {!this.getAppContext()
                                                            .media.isMobile &&
                                                          !this.getAppContext()
                                                            .media.isTablet ? (
                                                            <span
                                                              className={
                                                                "icon-play ml-2 align-self-center" +
                                                                (_selectedResult ==
                                                                _C
                                                                  ? ""
                                                                  : " invisible")
                                                              }
                                                            />
                                                          ) : null}
                                                        </ListGroupItem>
                                                      </LinkContainer>
                                                    );
                                                  },
                                                )}
                                              </ListGroup>
                                            </div>
                                          );
                                        },
                                      )}
                                    </div>
                                  );
                                })()}
                              </Col>
                              <Col
                                style={
                                  !this.getAppContext().media.isMobile
                                    ? { maxWidth: "84%" }
                                    : {}
                                }
                              >
                                {/* <Col xs={12} md={9}> */}
                                <Row noGutters className="border-bottom">
                                  <Col
                                    xs={12}
                                    md={
                                      this.state.data.measureResults[
                                        _selectedResult
                                      ].overlap.overlap_data &&
                                      this.state.data.measureResults[
                                        _selectedResult
                                      ].overlap.overlap_data.reference
                                        ? 9
                                        : 12
                                    }
                                    className="border-right border-gray300"
                                  >
                                    <SectionNEW
                                      VStretch
                                      layoutManager="grid"
                                      designType="wide"
                                      elementsPerRow={
                                        this.getAppContext().media.isMobile ||
                                        this.getAppContext().media.isTablet
                                          ? 1
                                          : 3
                                      }
                                      gridSpacing={1}
                                      gridSpacingColor={
                                        this.getAppContext().colors.gray300
                                      }
                                    >
                                      <div className="d-flex flex-column p-3">
                                        <div className="sub-title ">
                                          <strong>STATUS</strong>
                                        </div>
                                        <h4 className="d-flex align-items-start">
                                          <strong>
                                            {this.getStatusName(
                                              this.state.data.measureResults[
                                                _selectedResult
                                              ].summary,
                                            )}
                                          </strong>
                                        </h4>
                                        <div>
                                          {this.state.data.measureResults[
                                            _selectedResult
                                          ].pcap ||
                                          this.state.data.measureResults[
                                            _selectedResult
                                          ].lcap ? (
                                            <div>
                                              <div
                                                className="sub-title text-primary"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                  this.downloadPcap(
                                                    this.state.data.measureResults[
                                                      _selectedResult
                                                    ].bssid.replace(/:/g, ""),
                                                    this.state.data
                                                      .measureResults[
                                                      _selectedResult
                                                    ].pcap ||
                                                      this.state.data
                                                        .measureResults[
                                                        _selectedResult
                                                      ].lcap.pcap_ref,
                                                  );
                                                }}
                                              >
                                                <strong>Downloap .pcap</strong>
                                              </div>

                                              {this.state.data.measureResults[
                                                _selectedResult
                                              ].lcap ? (
                                                <div className="sub-title text-primary">
                                                  Last captured at{" "}
                                                  {this.getAppContext()
                                                    .momentjs(
                                                      this.state.data
                                                        .measureResults[
                                                        _selectedResult
                                                      ].lcap.pcap_ref_ts,
                                                      "X",
                                                    )
                                                    .format("L LTS")}
                                                </div>
                                              ) : null}
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                      <div className="d-flex flex-column p-3">
                                        <div className="sub-title">
                                          <strong>NETWORK</strong>
                                        </div>
                                        <h4 className="d-flex align-items-start">
                                          {this._measureInfo.essid || "-"}
                                        </h4>
                                        {overlap_data?.reference?.ois &&
                                          overlap_data.reference.ois != "" && (
                                            <div className="sub-title">
                                              {this.parseOis(
                                                overlap_data.reference.ois,
                                              )}
                                            </div>
                                          )}
                                      </div>
                                      {!/ethernet/i.test(
                                        this.state.data.essid,
                                      ) ? (
                                        <div className="d-flex">
                                          <div className="d-flex flex-column align-self-stretch p-3 w-100 bg-gray150">
                                            <div className="sub-title">
                                              <strong>OVERLAP INDEX</strong>
                                            </div>
                                            <h4 className="d-flex h-100 align-items-start">
                                              {overlap_data.reference &&
                                              overlap_data.overlap_index ? (
                                                overlap_data.overlap_index >
                                                  100 &&
                                                overlap_data.overlap_index <
                                                  200 ? (
                                                  <span className="text-danger">{`> 100`}</span>
                                                ) : overlap_data.overlap_index >
                                                  200 ? (
                                                  <span className="text-danger">{`>> 100`}</span>
                                                ) : (
                                                  <span
                                                    className={this.getAppContext().getRangeColor(
                                                      "overlap",
                                                      overlap_data.overlap_index,
                                                    )}
                                                  >
                                                    {overlap_data.overlap_index}
                                                  </span>
                                                )
                                              ) : (
                                                "-"
                                              )}
                                            </h4>
                                          </div>

                                          <div className="d-flex flex-column align-self-stretch p-3 w-100 bg-gray150 border-left">
                                            <div className="sub-title">
                                              <strong>RSSI</strong>
                                            </div>
                                            <h4
                                              className={`d-flex h-100 align-items-start`}
                                            >
                                              {overlap_data.reference?.rssi ? (
                                                <span
                                                  className={this.getAppContext().getRangeColor(
                                                    "rssi",
                                                    overlap_data.reference
                                                      ?.rssi,
                                                  )}
                                                >
                                                  {overlap_data.reference.rssi}{" "}
                                                  dBm
                                                </span>
                                              ) : (
                                                "-"
                                              )}
                                            </h4>
                                          </div>
                                        </div>
                                      ) : null}
                                      <div className="d-flex flex-column p-3">
                                        <div className="sub-title">
                                          <strong>TOTAL TIME</strong>
                                        </div>
                                        <h4 className="d-flex h-100 align-items-start">
                                          {(() => {
                                            let _total = 0;
                                            let _completed = true;
                                            this.state.data.measureResults[
                                              _selectedResult
                                            ].summary.steps.forEach(
                                              (_CURR_phase) => {
                                                if (
                                                  /^(\d+)$/.test(_CURR_phase[1])
                                                ) {
                                                  _total =
                                                    _total +
                                                    parseInt(_CURR_phase[1]);
                                                } else {
                                                  _completed = false;
                                                }
                                              },
                                            );
                                            return (
                                              <strong
                                                id={
                                                  !_completed
                                                    ? "_tooltip_partial_time_"
                                                    : null
                                                }
                                              >
                                                {_total} ms
                                                {!_completed ? (
                                                  <span>
                                                    <ReactOTooltip
                                                      placement="bottom"
                                                      target="_tooltip_partial_time_"
                                                      text="Partial time. Measure not completed"
                                                    />
                                                    <span className="sub-title icon-warning ml-2" />
                                                  </span>
                                                ) : null}
                                              </strong>
                                            );
                                          })()}
                                        </h4>
                                        {this.state.data.measureResults[
                                          _selectedResult
                                        ].antenna_mac ? (
                                          <div className="sub-title">
                                            Antenna:{" "}
                                            {this.state.data.measureResults[
                                              _selectedResult
                                            ].antenna_mac
                                              .replace(/(..)/g, "$1:")
                                              .slice(0, -1)}
                                          </div>
                                        ) : null}
                                      </div>

                                      {!/ethernet/i.test(
                                        this.state.data.essid,
                                      ) ? (
                                        <div className="d-flex flex-column p-3">
                                          <div className="sub-title">
                                            <strong>
                                              <span className="icon-router mr-2" />
                                              BSSID
                                            </strong>
                                          </div>
                                          <h4 className="d-flex h-100 align-items-start">
                                            <strong>
                                              {/* {this.state.data.measureResults[_selectedResult].bssid} */}
                                              {this.state.data.measureResults[
                                                _selectedResult
                                              ].bssid_info ? (
                                                this.state.data.measureResults[
                                                  _selectedResult
                                                ].bssid_info.ap_custom_data ? (
                                                  (() => {
                                                    let _tooltip_id = this.state
                                                      .data.measureResults[
                                                      _selectedResult
                                                    ].bssid_info.ap_custom_data
                                                      .mac_lan
                                                      ? "_ap_cst_" +
                                                        this.state.data.measureResults[
                                                          _selectedResult
                                                        ].bssid.replace(
                                                          /:/g,
                                                          "",
                                                        ) +
                                                        "_" +
                                                        this.state.data.measureResults[
                                                          _selectedResult
                                                        ].bssid_info.ap_custom_data.mac_lan.replace(
                                                          /:/g,
                                                          "",
                                                        )
                                                      : null;
                                                    return (
                                                      <div
                                                        style={{
                                                          textOverflow:
                                                            "ellipsis",
                                                          overflow: "hidden",
                                                          whiteSpace: "nowrap",
                                                          maxWidth: "310px",
                                                        }}
                                                        id={_tooltip_id}
                                                      >
                                                        {this.state.data
                                                          .measureResults[
                                                          _selectedResult
                                                        ].bssid_info
                                                          .ap_custom_data
                                                          .mac_lan ? (
                                                          <ReactOTooltip
                                                            placement="bottom"
                                                            target={_tooltip_id}
                                                            text={
                                                              "LAN mac address: " +
                                                              this.state.data
                                                                .measureResults[
                                                                _selectedResult
                                                              ].bssid_info
                                                                .ap_custom_data
                                                                .mac_lan
                                                            }
                                                          />
                                                        ) : null}
                                                        {this.state.data
                                                          .measureResults[
                                                          _selectedResult
                                                        ].bssid_info
                                                          .ap_custom_data.name +
                                                          (this.state.data
                                                            .measureResults[
                                                            _selectedResult
                                                          ].bssid_info
                                                            .ap_custom_data
                                                            .ip == ""
                                                            ? ""
                                                            : " - " +
                                                              this.state.data
                                                                .measureResults[
                                                                _selectedResult
                                                              ].bssid_info
                                                                .ap_custom_data
                                                                .ip)}
                                                      </div>
                                                    );
                                                  })()
                                                ) : (
                                                  <div>
                                                    {
                                                      this.state.data
                                                        .measureResults[
                                                        _selectedResult
                                                      ].bssid
                                                    }
                                                  </div>
                                                )
                                              ) : null}
                                            </strong>
                                          </h4>
                                          {this.state.data.measureResults[
                                            _selectedResult
                                          ].bssid_info ? (
                                            this.state.data.measureResults[
                                              _selectedResult
                                            ].bssid_info.ap_custom_data ? (
                                              <span className="sub-title">
                                                {
                                                  this.state.data
                                                    .measureResults[
                                                    _selectedResult
                                                  ].bssid
                                                }
                                              </span>
                                            ) : (
                                              <span className="sub-title">
                                                {this.state.data.measureResults[
                                                  _selectedResult
                                                ].bssid_info.long_desc
                                                  ? this.state.data
                                                      .measureResults[
                                                      _selectedResult
                                                    ].bssid_info.long_desc
                                                  : null}
                                              </span>
                                            )
                                          ) : null}
                                        </div>
                                      ) : null}

                                      {!/ethernet/i.test(
                                        this.state.data.essid,
                                      ) ? (
                                        this.state.data.measureResults[
                                          _selectedResult
                                        ].overlap &&
                                        this.state.data.measureResults[
                                          _selectedResult
                                        ].overlap.overlap_data.reference &&
                                        this.state.data.measureResults[
                                          _selectedResult
                                        ].overlap.overlap_data.reference
                                          .beacon_bw_carrier ? (
                                          <div className="d-flex flex-column p-3 bg-gray150 h-100">
                                            <div className="sub-title">
                                              <strong>
                                                FREQUENCY AND BEACON
                                                {/* {" "}
                                          {this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap.overlap_data.reference
                                                .beacon_bw_carrier ==
                                                this.state.data.measureResults[
                                                  _selectedResult
                                                ].overlap.overlap_data.reference
                                                  .bw_carrier && "AND BEACON"} */}
                                              </strong>
                                            </div>
                                            <h4 className="d-flex align-items-start">
                                              <strong id="_tooltip_channel_">
                                                {
                                                  this.state.data
                                                    .measureResults[
                                                    _selectedResult
                                                  ].overlap.overlap_data
                                                    .reference.bw_carrier
                                                }{" "}
                                                MHz
                                              </strong>
                                              {this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap.overlap_data.reference
                                                .beacon_bw_carrier !=
                                              this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap.overlap_data.reference
                                                .bw_carrier ? (
                                                <span className="sub-title sub-title-inline ml-1">
                                                  {" "}
                                                  Channel{" "}
                                                  {
                                                    this.state.data
                                                      .measureResults[
                                                      _selectedResult
                                                    ].overlap.overlap_data
                                                      .reference.bw_channel
                                                  }
                                                </span>
                                              ) : null}
                                            </h4>

                                            {this.state.data.measureResults[
                                              _selectedResult
                                            ].overlap.overlap_data.reference
                                              .beacon_bw_carrier !=
                                            this.state.data.measureResults[
                                              _selectedResult
                                            ].overlap.overlap_data.reference
                                              .bw_carrier ? (
                                              <div className="sub-title">
                                                Beacon:{" "}
                                                {
                                                  this.state.data
                                                    .measureResults[
                                                    _selectedResult
                                                  ].overlap.overlap_data
                                                    .reference.beacon_bw_carrier
                                                }{" "}
                                                MHz (Channel{" "}
                                                {this.state.data.measureResults[
                                                  _selectedResult
                                                ].overlap.overlap_data.reference
                                                  .beacon_bw_channel
                                                  ? this.state.data
                                                      .measureResults[
                                                      _selectedResult
                                                    ].overlap.overlap_data
                                                      .reference
                                                      .beacon_bw_channel
                                                  : "-"}
                                                )
                                              </div>
                                            ) : (
                                              <div className="sub-title">
                                                Channel{" "}
                                                {
                                                  this.state.data
                                                    .measureResults[
                                                    _selectedResult
                                                  ].overlap.overlap_data
                                                    .reference.bw_channel
                                                }
                                              </div>
                                            )}
                                          </div>
                                        ) : (
                                          <div className="d-flex flex-column p-3 bg-gray150 h-100">
                                            <div className="sub-title ">
                                              <strong>FREQUENCY</strong>
                                            </div>
                                            <h4 className="d-flex align-items-start">
                                              {this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap &&
                                              this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap.overlap_data &&
                                              this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap.overlap_data
                                                .reference &&
                                              this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap.overlap_data.reference
                                                .bw_carrier ? (
                                                <strong id="_tooltip_channel_">
                                                  {
                                                    this.state.data
                                                      .measureResults[
                                                      _selectedResult
                                                    ].overlap.overlap_data
                                                      .reference.bw_carrier
                                                  }{" "}
                                                  MHz
                                                </strong>
                                              ) : (
                                                "-"
                                              )}
                                            </h4>
                                            {this.state.data.measureResults[
                                              _selectedResult
                                            ].overlap &&
                                              this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap.overlap_data &&
                                              this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap.overlap_data
                                                .reference &&
                                              this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap.overlap_data
                                                .reference &&
                                              this.state.data.measureResults[
                                                _selectedResult
                                              ].overlap.overlap_data.reference
                                                .bw_channel && (
                                                <div className="sub-title">
                                                  Channel{" "}
                                                  {
                                                    this.state.data
                                                      .measureResults[
                                                      _selectedResult
                                                    ].overlap.overlap_data
                                                      .reference.bw_channel
                                                  }
                                                </div>
                                              )}
                                          </div>
                                        )
                                      ) : null}
                                    </SectionNEW>
                                  </Col>
                                  {!/ethernet/i.test(this.state.data.essid) &&
                                  overlap_data &&
                                  overlap_data.reference ? (
                                    <Col xs={12} md={3}>
                                      <div className="d-flex flex-column align-self-center p-3 bg-gray150 h-100">
                                        <div className="d-flex mb-2">
                                          <div className="sub-title flex-grow-1">
                                            <strong className="mr-3">
                                              OVERLAP GRAPH
                                            </strong>
                                          </div>
                                          <div>
                                            <ReactOButton
                                              outline
                                              size="sm"
                                              onClick={() => {
                                                this._overlap_modal.open({
                                                  ...overlapData,
                                                  ...{
                                                    ts: this.state.data
                                                      .measureResults[
                                                      _selectedResult
                                                    ].etime,
                                                  },
                                                });
                                              }}
                                            >
                                              More
                                            </ReactOButton>
                                          </div>
                                        </div>
                                        <div
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            this._overlap_modal.open({
                                              ...overlapData,
                                              ...{
                                                ts: this.state.data
                                                  .measureResults[
                                                  _selectedResult
                                                ].etime,
                                              },
                                            });
                                          }}
                                        >
                                          {this.state.data.measureResults[
                                            _selectedResult
                                          ].overlap.overlap_data.reference ? (
                                            <BandwidthOverlapChart
                                              data={overlapData}
                                              showBeacon={false}
                                              // aspectRatio={2.4}
                                              maxHeight={120}
                                            />
                                          ) : null}
                                        </div>
                                      </div>
                                    </Col>
                                  ) : null}
                                </Row>
                                {/* 
                              ---
                              -------- VIEW MODE --------
                              ---
                              */}

                                {this.viewMode == "list" && (
                                  <ListView
                                    viewHar={this.viewHar.bind(this)}
                                    downloadHar={this.downloadHar.bind(this)}
                                    viewStep={this.viewStep.bind(this)}
                                    viewLogcat={this.viewLogcat.bind(this)}
                                    selectedResult={_selectedResult}
                                    listData={
                                      this.state.data.measureResults[
                                        _selectedResult
                                      ]
                                    }
                                    _overlap_modal_img={this._overlap_modal_img}
                                    _overlap_modal_video={
                                      this._overlap_modal_video
                                    }
                                    _overlap_modal_screen={
                                      this._overlap_modal_screen
                                    }
                                  />
                                )}

                                {this.viewMode == "grid" && (
                                  <GridView
                                    innerRef={this.child}
                                    viewHar={this.viewHar.bind(this)}
                                    downloadHar={this.downloadHar.bind(this)}
                                    viewStep={this.viewStep.bind(this)}
                                    viewLogcat={this.viewLogcat.bind(this)}
                                    selectedResult={_selectedResult}
                                    listData={
                                      this.state.data.measureResults[
                                        _selectedResult
                                      ]
                                    }
                                    _overlap_modal_img={this._overlap_modal_img}
                                    _overlap_modal_video={
                                      this._overlap_modal_video
                                    }
                                    _overlap_modal_screen={
                                      this._overlap_modal_screen
                                    }
                                  />
                                )}

                                {/* --- END VIEW --- */}
                              </Col>
                            </Row>
                          </Panel>
                        </Col>
                      </Row>
                    );
                  })()
                ) : (
                  <div className="text-center text-muted">
                    {this.state.loading
                      ? null
                      : this.props.match.params.ts >
                          this.getAppContext().momentjs().unix()
                        ? "No measures done (Future Time)"
                        : this.state.data &&
                            this.state.data.measured_times &&
                            this.state.data.measured_times.lastRRD &&
                            this.props.match.params.ts <
                              this.state.data.measured_times.lastRRD &&
                            this.state.data.measured_times.next_measured !=
                              99999999960
                          ? "No measures on the minute"
                          : "Waiting for probe data"}
                  </div>
                )}
              </_LoadingWrapper>
            </div>
          </Section>
        )}

        {/*				
// Modals
///////////////////////*/}

        <ReactOModal
          modalId="overlap"
          size="lg"
          onControllerReady={(modal_context) => {
            this._overlap_modal = modal_context;
          }}
          header={(data) => {
            return (
              <div>
                Bandwidths overlap detail
                <small className="text-left d-flex align-items-center">
                  <div className="flex-shrink-1 mr-2">
                    <strong className="sub-title">AT DATETIME:</strong>
                    <strong className="pl-2">
                      <span>
                        {this.getAppContext()
                          .momentjs(data.ts, "X")
                          .format("L LTS")}
                      </span>
                    </strong>
                  </div>
                </small>
              </div>
            );
          }}
          bodyClassName="p-0"
          body={(data) => {
            return data.reference ? (
              <div className="bg-light rounded-bottom">
                <Section
                  className="border-bottom border-2 border-gray300"
                  layoutManager="grid"
                  elementsPerRow={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                      ? 1
                      : 2
                  }
                  gridSpacing={1}
                  gridSpacingColor={this.getAppContext().colors.gray300}
                >
                  <Section
                    layoutManager="grid"
                    elementsPerRow={1}
                    gridSpacing={1}
                    gridSpacingColor={this.getAppContext().colors.gray300}
                  >
                    <div className="d-flex flex-column p-3">
                      <div className="sub-title mb-2">
                        <strong>
                          <span className="icon-router mr-2" />
                          BSSID
                        </strong>
                      </div>
                      <h4 className="d-flex h-100 align-items-start">
                        {data.reference.bssid}
                      </h4>
                      {data.reference.bssid_info ? (
                        <div className="sub-title">
                          {data.reference.bssid_info.ap_custom_data ? (
                            (() => {
                              let _tooltip_id = data.reference.bssid_info
                                .ap_custom_data.mac_lan
                                ? "_ap_cst_modal_ref_" +
                                  data.reference.bssid.replace(/:/g, "") +
                                  "_" +
                                  data.reference.bssid_info.ap_custom_data.mac_lan.replace(
                                    /:/g,
                                    "",
                                  )
                                : null;
                              return (
                                <div id={_tooltip_id}>
                                  {data.reference.bssid_info.ap_custom_data
                                    .mac_lan ? (
                                    <ReactOTooltip
                                      placement="bottom"
                                      target={_tooltip_id}
                                      text={
                                        "LAN mac address: " +
                                        data.reference.bssid_info.ap_custom_data
                                          .mac_lan
                                      }
                                    />
                                  ) : null}
                                  {data.reference.bssid_info.ap_custom_data
                                    .name +
                                    (data.reference.bssid_info.ap_custom_data
                                      .ip == ""
                                      ? ""
                                      : " - " +
                                        data.reference.bssid_info.ap_custom_data
                                          .ip)}
                                </div>
                              );
                            })()
                          ) : (
                            <div>{data.reference.bssid_info.long_desc}</div>
                          )}
                        </div>
                      ) : null}
                    </div>
                    <div className="d-flex flex-column p-3">
                      <div className="d-flex flex-row bd-highlight mb-3">
                        <div className="d-flex flex-column mr-3 pr-3">
                          <div className="sub-title">
                            <strong>OVERLAP INDEX</strong>
                          </div>
                          <h4 className="d-flex align-items-start">
                            {data.overlap_index ? (
                              data.overlap_index > 100 &&
                              data.overlap_index < 200 ? (
                                <span className="text-danger">{`> 100`}</span>
                              ) : data.overlap_index > 200 ? (
                                <span className="text-danger">{`>> 100`}</span>
                              ) : (
                                <span
                                  className={this.getAppContext().getRangeColor(
                                    "overlap",
                                    data.overlap_index,
                                  )}
                                >
                                  {data.overlap_index}
                                </span>
                              )
                            ) : (
                              "-"
                            )}
                          </h4>

                          <div className="sub-title mt-3">
                            <strong>RSSI</strong>
                          </div>
                          <h4 className="d-flex align-items-start">
                            {data.reference?.rssi ? (
                              <span
                                className={this.getAppContext().getRangeColor(
                                  "rssi",
                                  data.reference?.rssi,
                                )}
                              >
                                {data.reference.rssi} dBm
                              </span>
                            ) : (
                              "-"
                            )}
                          </h4>
                        </div>

                        {data.reference.beacon_bw_carrier ? (
                          <div className="d-flex flex-column ml-3 pl-3 align-items-start">
                            <div className="sub-title">
                              <strong>
                                FREQUENCY{" "}
                                {data.reference.beacon_bw_carrier ==
                                  data.reference.bw_carrier && "AND BEACON"}
                              </strong>
                            </div>
                            <h4 className="d-flex align-items-start">
                              {data.reference.bw_carrier} MHz
                            </h4>
                            <div className="sub-title">
                              Channel {data.reference.bw_channel}
                            </div>
                            {data.reference.beacon_bw_carrier !=
                              data.reference.bw_carrier && (
                              <div className="sub-title">
                                Beacon: {data.reference.beacon_bw_carrier} MHz
                                (Ch.{" "}
                                {data.reference.beacon_bw_channel
                                  ? data.reference.beacon_bw_channel
                                  : "-"}
                                )
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="d-flex flex-column ml-3 pl-3">
                            <div className="sub-title">
                              <strong>FREQUENCY</strong>
                            </div>
                            <h4 className="d-flex h-100 align-items-start">
                              {data.reference.bw_carrier} MHz
                            </h4>
                          </div>
                        )}
                      </div>
                    </div>
                  </Section>
                  <div className="d-flex flex-column p-3">
                    <div className="sub-title mb-2">
                      <strong>BANDWIDTHS OVERLAP GRAPH</strong>
                    </div>
                    {data.reference ? (
                      <BandwidthOverlapChart
                        data={data}
                        showBeacon={true}
                        bssidActive={this.state.bssid_active}
                        aspectRatio={2}
                      />
                    ) : null}
                  </div>
                </Section>
                {this.state.data.spectro_enabled == "yes" ? (
                  <div className="d-flex flex-column p-3">
                    <div className="sub-title mb-2">
                      <strong>WATERFALL</strong>
                    </div>
                    <SpectroChart
                      data={data}
                      freq={data.reference.bw_carrier}
                      etime={data.ts}
                      stime={data.st}
                      probeid={this.props.match.params.probeuid}
                      sec_to_get="60"
                      aspectRatio={5.8}
                    />
                  </div>
                ) : null}
                {this.state.data.spectro_enabled == "yes" ? (
                  <div className="d-flex flex-column p-3">
                    <div className="sub-title mb-3">
                      <strong>DENSITY</strong>
                    </div>
                    <SpectroChart2
                      data={data}
                      freq={data.reference.bw_carrier}
                      etime={data.ts}
                      stime={data.st}
                      probeid={this.props.match.params.probeuid}
                      sec_to_get="60"
                      aspectRatio={5.8}
                    />
                  </div>
                ) : null}
                <div
                  id="tableOverlap"
                  style={{ maxHeight: "65vh" }}
                  className="overflow-auto pb-3"
                >
                  <ReactOTable
                    thClassName="px-3 py-1"
                    tdClassName="align-middle px-3 py-2"
                    thDividers
                    bordless
                    // hoverable
                    compressed={
                      this.getAppContext().media.isMobile ||
                      this.getAppContext().media.isTablet
                    }
                    compressedRowRendering={(row_items) => {
                      return (
                        <div>
                          <Row className="mt-2">
                            <Col>
                              <div className="text-muted">
                                <small className="">
                                  <strong>{row_items.bssid.title}</strong>
                                </small>
                              </div>
                              {row_items.bssid.content}
                            </Col>
                            <Col>
                              <div className="text-muted">
                                <small className="">
                                  <strong>{row_items.freq.title}</strong>
                                </small>
                              </div>
                              {row_items.freq.content}
                            </Col>
                          </Row>
                          <Row className="mt-2">
                            <Col>
                              <div className="text-muted">
                                <small className="">
                                  <strong>{row_items.rssi.title}</strong>
                                </small>
                              </div>
                              {row_items.rssi.content}
                            </Col>
                            <Col>
                              <div className="text-muted">
                                <small className="">
                                  <strong>{row_items.essid.title}</strong>
                                </small>
                              </div>
                              {row_items.essid.content}
                            </Col>
                          </Row>
                        </div>
                      );
                    }}
                    onTableLeave={() => {
                      this.setState({ bssid_active: undefined, over: false });
                    }}
                    onRowOver={(row_data) => {
                      // console.log("row_data_over", row_data);
                      this.setState({
                        bssid_active: row_data.bssid.value,
                        over: true,
                      });
                    }}
                    // defaultSort={[
                    //   {
                    //     data_key: "rssi",
                    //     order: "desc",
                    //   },
                    //   {
                    //     data_key: "bssid",
                    //     order: "desc",
                    //   },
                    // ]}
                    cols={[
                      {
                        title: "BSSID",
                        data_key: "bssid",
                        width: "25",
                        sortable: false,
                      },
                      {
                        title: "FREQUENCY",
                        align: "center",
                        data_key: "freq",
                        width: "15",
                        sortable: false,
                      },
                      {
                        title: "RSSI",
                        align: "center",
                        data_key: "rssi",
                        width: "10",
                        sortable: false,
                        icon: "icon-caret-down",
                      },
                      {
                        title: "ESSID",
                        data_key: "essid",
                        width: "25",
                        sortable: false,
                      },
                    ]}
                    rows={(() => {
                      let _TMP = [];
                      let sorted = [];

                      let sortedFirst = [
                        ...[data.reference],
                        ...data.overlapping,
                      ].sort((a, b) => {
                        return b.rssi - a.rssi;
                      });

                      let tableOfSort = sortedFirst.filter(
                        (value, index, self) =>
                          index ===
                          self.findIndex(
                            (t) => t.bssid_orig === value.bssid_orig,
                          ),
                      );

                      tableOfSort.forEach(({ bssid_orig }) => {
                        let filter = sortedFirst.filter((elem) => {
                          return elem.bssid_orig == bssid_orig;
                        });

                        Array.prototype.push.apply(sorted, filter);
                      });

                      // [...[data.reference], ...data.overlapping]

                      sorted.forEach((_C_network, _C_idx) => {
                        _TMP.push({
                          ...this.setTableClassName(
                            _C_network,
                            data,
                            tableOfSort,
                          ),
                          index: _C_idx,
                          _rowTooltip: {
                            targetId: "tp_" + _C_idx,
                            text: this.setTooltipText(_C_network, data),
                            delay: { show: 200 },
                          },
                          essid: {
                            value: _C_network.essid,
                            render: (
                              <div>
                                {_C_network.essid}
                                <div className="sub-title mt-1">
                                  {_C_network.ois && _C_network.ois != "" && (
                                    <span>{this.parseOis(_C_network.ois)}</span>
                                  )}
                                </div>
                              </div>
                            ),
                          },
                          freq: {
                            value: _C_network.bw_carrier,
                            render: (
                              <span>
                                <strong>
                                  {_C_network.bw_carrier
                                    ? _C_network.bw_carrier
                                    : "-"}{" "}
                                  MHz
                                </strong>
                                <div className="sub-title">
                                  Channel{" "}
                                  {_C_network.bw_channel
                                    ? _C_network.bw_channel
                                    : "-"}
                                </div>
                              </span>
                            ),
                          },
                          rssi: {
                            value: _C_network.rssi,
                            render: (
                              <span>
                                <strong>{_C_network.rssi} dBm</strong>
                              </span>
                            ),
                          },
                          bssid: {
                            value: _C_network.bssid_orig,
                            render: (
                              <span className="sub-title">
                                <span
                                  className={
                                    _C_network.bssid == data.reference.bssid
                                      ? "text-primary"
                                      : ""
                                  }
                                >
                                  <strong>{_C_network.bssid}</strong>
                                </span>
                                {_C_network.bssid_info ? (
                                  _C_network.bssid_info.ap_custom_data ? (
                                    <div>
                                      {_C_network.bssid_info.ap_custom_data
                                        .name +
                                        (_C_network.bssid_info.ap_custom_data
                                          .ip == ""
                                          ? ""
                                          : " - " +
                                            _C_network.bssid_info.ap_custom_data
                                              .ip)}
                                    </div>
                                  ) : (
                                    <div>{_C_network.bssid_info.long_desc}</div>
                                  )
                                ) : null}
                              </span>
                            ),
                          },
                        });
                      });
                      return _TMP;
                    })()}
                  />
                </div>
              </div>
            ) : null;
          }}
        />

        {/* MODAL IMG */}
        <ReactOModal
          modalId="imgClick"
          size="lg"
          onControllerReady={(modal_context) => {
            this._overlap_modal_img = modal_context;
          }}
          header="Screenshot from chrome"
          body={(data) => {
            return (
              <div>
                <div className="mb-2">
                  <img
                    className="w-100 border rounded"
                    alt="sceenshot"
                    src={data.url}
                  />
                </div>

                <Panel
                  rounded
                  className="bg-dark mb-4"
                  bodyClassName="d-flex p-3"
                >
                  {/* <div className="flex-grow-1 d-flex align-items-center">
								<div className="text-light m-0">Download size : <strong>{data.size + 'K'}</strong></div>
							</div> */}
                  <div>
                    <ReactOButton
                      className="text-center"
                      onClick={() => {
                        this.downloadScreenshot(data.bssid, data.chromiumJpeg);
                      }}
                      icon="picture"
                    >
                      Download
                    </ReactOButton>
                  </div>
                </Panel>
              </div>
            );
          }}
        />

        {/* MODAL SCREEN PNG */}
        <ReactOModal
          modalId="screenClick"
          // size="xl"
          onControllerReady={(modal_context) => {
            this._overlap_modal_screen = modal_context;
          }}
          onModalUnmounted={() => {
            this.setState({ zoom_image: false });
          }}
          className="max-width-96"
          header={(data) =>
            data.screendoctitle ? data.screendoctitle : "Screenshot"
          }
          body={(data) => {
            return (
              <div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleZoomImage();
                  }}
                  class={`${
                    this.state.zoom_image ? "cursor-zoom-out" : "cursor-zoom-in"
                  } mb-2 HoverDiv`}
                >
                  <img
                    className={`${this.state.zoom_image ? "" : " w-100"}`}
                    alt="sceenshot"
                    src={data.url}
                  />
                </div>

                <Panel
                  rounded
                  className="bg-dark mb-4"
                  bodyClassName="d-flex p-3"
                >
                  <div>
                    <ReactOButton
                      className="text-center"
                      onClick={() => {
                        this.downloadScreenshot(data.bssid, data.chromiumJpeg);
                      }}
                      icon="picture"
                    >
                      Download
                    </ReactOButton>
                  </div>
                </Panel>
              </div>
            );
          }}
        />

        {/* MODAL VIDEO */}

        <ReactOModal
          modalId="videoClick"
          size="lg"
          onControllerReady={(modal_context) => {
            this._overlap_modal_video = modal_context;
          }}
          onModalUnmounted={(data) => {
            this.setState({ disableVideoBtn: false });
          }}
          header="Video"
          body={(data) => {
            return (
              <div>
                <div className="mb-2">
                  <video width="100%" height="360" controls autoPlay>
                    <source src={data.url} type="video/mp4" />
                  </video>
                </div>

                <Panel
                  rounded
                  className="bg-dark mb-4"
                  bodyClassName="d-flex p-3"
                >
                  {data.chromiumLmp4 ? (
                    <div>
                      <a
                        href={
                          "https://" +
                          new URL(data.url).hostname +
                          "/d" +
                          new URL(data.url).pathname
                        }
                      >
                        <ReactOButton
                          disabled={this.state.disableVideoBtn}
                          className="text-center"
                          onClick={() => {
                            this.handleClickVideo();
                            // download(data.url);
                          }}
                          icon="file-video"
                        >
                          Download
                        </ReactOButton>
                      </a>
                    </div>
                  ) : (
                    <div>
                      <ReactOButton
                        className="text-center"
                        disabled={this.state.disableVideoBtn}
                        onClick={() => {
                          this.handleClickVideo();
                          this.downloadScreenshot(
                            data.bssid,
                            data.chromiumVideo,
                          );
                        }}
                        icon="file-video"
                      >
                        Download
                      </ReactOButton>
                    </div>
                  )}
                </Panel>
              </div>
            );
          }}
        />

        {/* MODAL SCREEN */}
        {/* 
 <ReactOModal
          modalId="screendoc"
          size="xl"
          onControllerReady={(modal_context) => {
            this._overlap_modal_screendoc = modal_context;
          }}
          // onModalUnmounted={(data) => {
          //   this.setState({ disableVideoBtn: false });
          // }}
          header="Screen"
          body={(data) => {
            return (
              <div>
                <div className="mb-2">
                  <video width="100%" height="360" controls autoPlay>
                    <source src={data.url} type="video/mp4" />
                  </video>
                </div>

                <Panel rounded className="bg-dark mb-4" bodyClassName="d-flex p-3">
                  {data.chromiumLmp4 ? (
                    <div>
                      <a
                        href={
                          "https://" +
                          new URL(data.url).hostname +
                          "/d" +
                          new URL(data.url).pathname
                        }
                      >
                        <ReactOButton
                          disabled={this.state.disableVideoBtn}
                          className="text-center"
                          onClick={() => {
                            this.handleClickVideo();
                            // download(data.url);
                          }}
                          icon="file-video"
                        >
                          Download
                        </ReactOButton>
                      </a>
                    </div>
                  ) : (
                    <div>
                      <ReactOButton
                        className="text-center"
                        disabled={this.state.disableVideoBtn}
                        onClick={() => {
                          this.handleClickVideo();
                          this.downloadScreenshot(data.bssid, data.chromiumVideo);
                        }}
                        icon="file-video"
                      >
                        Download
                      </ReactOButton>
                    </div>
                  )}
                </Panel>
              </div>
            );
          }}
        /> */}

        <NotesEditor
          probeuid={this.props.match.params.probeuid}
          measureid={this.props.match.params.measureid}
          //	notes={this.state.measure_graph.notes}
          onNewNotesAvailable={(new_notes, cb) => {
            this.setState((prev_state) => {
              prev_state.notes = new_notes;
              return prev_state;
            }, cb);
          }}
          onLoadingStarted={(cb) => {
            this.setState({ loading_notes: true }, cb);
          }}
          onLoadingStopped={(cb) => {
            this.setState({ loading_notes: false }, cb);
          }}
          onReady={(notes_editing_ctrl) => {
            this._notes_editing_ctrl = notes_editing_ctrl;
          }}
        />
      </Section>
    );
  }
}

export default contextProvider(ProbeMeasureResults, {
  define: null,
});
